import { useLocalization } from '@/hooks/useLocalization';
import { authControlStyles as controls } from './AuthControls';
import styles from './authDialogs.module.css';

/**
 * WarningDialog — an optional title, a message and one button. It can't be dismissed by
 * tapping outside.
 *
 * Mirrors Flutter CustomDialog.showWarningDialog (presentation/common/custom_dialog.dart), which
 * the MFA page shows for "User authenticated successfully" and the "Error / Too many requests"
 * message. Texts are Flutter's untranslated English.
 */

interface WarningDialogProps {
  title?: string;
  content: string;
  btnText?: string;
  onOk: () => void;
}

export function WarningDialog({ title = '', content, btnText = 'OK', onOk }: WarningDialogProps) {
  const { t } = useLocalization();

  return (
    <div className={styles.barrier}>
      <div
        className={`${styles.dialog} ${styles.warning}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={title ? 'warning-dialog-title' : undefined}
        aria-label={title ? undefined : t(content)}
      >
        <div className={styles.messageBody}>
          {title && <h2 id="warning-dialog-title" className={styles.warningTitle}>{t(title)}</h2>}
          <p className={styles.warningText}>{t(content)}</p>
          <button
            type="button"
            className={`${controls.outlinedButton} ${styles.messageBtn}`}
            onClick={onOk}
            autoFocus
          >
            {t(btnText)}
          </button>
        </div>
      </div>
    </div>
  );
}
